export enum QaFilter {
  DocumentStatus = 'Document Status',
  SignatureStatus = 'Signature Status',
  QaDate = 'Qa Date',
}

export enum Verdict {
  Pass = 'Pass',
  Fail = 'Fail',
}

export enum SessionEvalSchemaVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export enum CQAReviewStatus {
  InProgress = 'IN_PROGRESS',
  AwaitingAcknowledgement = 'AWAITING_ACKNOWLEDGEMENT',
  Acknowledged = 'ACKNOWLEDGED',
}

export const oneWeek = 7;

export enum ReasonForDeletion {
  Correction = 'Correction',
  Incomplete = 'Incomplete',
}
